import { __read, __spreadArray } from "tslib";
import { MiniCartEvents } from '../constants';
import { isWorker } from '../viewer-script/utils';
export function loadMiniCartIfNotLoaded(context) {
    var _a;
    if (context.tinyCartParams) {
        var params = context.tinyCartParams;
        context.tinyCartParams = undefined;
        var resolve_1;
        var waitToFinishPreload = new Promise(function (r) { return (resolve_1 = r); });
        context.siteStore.pubSub.subscribe(MiniCartEvents.OnInitialData, function () { return resolve_1(); }, false);
        void (_a = context.siteStore.windowApis).openPersistentPopup.apply(_a, __spreadArray([], __read(params), false));
        return waitToFinishPreload;
    }
}
export function shouldOpenMiniCart(context) {
    var cartExists = context.siteStore.isCartExists;
    var isViewer = context.siteStore.isSiteMode() || context.siteStore.isPreviewMode();
    var isLightbox = !!context.siteStore.windowApis.lightbox.getContext();
    return !context.siteStore.isMobile() && isViewer && isWorker() && cartExists && !isLightbox;
}
//# sourceMappingURL=miniCart.utils.js.map